import PersonalCenter from './pofile';

export default PersonalCenter;
